import React from 'react'

import { Loading, Modal, Button } from '@buildbox/components'
import {
	ModalConfigurationTitle,
	SwitchesRow,
	SwitchesRowLabel,
	SwitchesWrapper,
	SwitchContainer,
	Separator
} from '../../shared/components/ModalStyledComponents'
import {
	colors,
	primaryInputStyle,
	primaryButtonStyle,
	selectStyle
} from 'shared/styles/theme'
import EditorTextBox from 'shared/components/EditorTextBox'
import ViewErrors from 'shared/components/ViewErrors'
import {
	ModalReportWrapper,
	ModalDeleteReport,
	ImageInputWrapper,
	SwitchWrapper,
	ModalContainerWrapper,
	LanguageLabel,
	SwicthLabelContainer
} from './styles'
import { IViewProps } from './types'
import Switch from 'shared/components/Switch'
import ImageUpload from 'shared/components/ImageUpload'
import { Column, Row } from 'shared/styles'
import PdfFiles from 'shared/components/PdfFiles'
import { defineModalButtonName, defineModalTitle } from './util'
import { IMAGE_INITIAL_VALUE } from 'shared/util/Consts'
import ResponsiveInput from '../../shared/components/ResponsiveInput'
import SwitchLanguage from 'shared/components/SwitchLanguage'
import FloatLabelInput from 'shared/components/FloatLabelInput'
import Select from 'shared/components/Select'
import { SectionBZElections } from './SectionBZElections'
import SectionSpeechForm from 'shared/components/SectionSpeechForm'
import { ReportCategory } from 'shared/interfaces/report'

function ModalReport(props: IViewProps) {
	const {
		isActive,
		modalAction,
		currentReport,
		hideModal,
		isLoading,
		initializeReportFields,
		handleImage,
		modalValue,
		modalOptions,
		handleEditor,
		handleSelectChange,
		handleTitle,
		handleSubtitle,
		handleYoutubeLink,
		handlePdf,
		handleSubmit,
		handleDelete,
		setNotificate,
		setEmailNotificate,
		setIsPublic,
		handleSelectCategoryChange,
		handleSelectSubcategory,
		setSwitchValue,
		switchValue,
		graphLink,
		handleGraphLink,
		BZElectionAccess,
		delayTimeInMacroPolitical,
		handleElectionAccess,
		handleDelayMinuteChange,
		isFixed,
		handleIsFixed,
		speechDate,
		speechValue,
		handleSpeechChange,
		handleSpeechTextInput
	} = props

	const isBzElectionCategory =
		modalValue.category && modalValue.category.value === 'BZ_ELECTION'

	const isSpeech = modalValue.category && modalValue.category.value === 'SPEECH'

	return (
		<ModalContainerWrapper>
			<Modal
				className='modal-primary'
				title={defineModalTitle(modalAction)}
				size={modalAction !== 'DELETE' ? 752 : 375}
				isActive={isActive}
				onClose={() => {
					hideModal()
					initializeReportFields()
					handleImage(IMAGE_INITIAL_VALUE)
				}}
				scrollRef='scroll-ref'
			>
				{modalAction !== 'DELETE' ? (
					<ModalReportWrapper>
						<div className='upper-section'>
							<ImageInputWrapper>
								<Column sm='12' lg='6'>
									<ImageUpload
										returnImage={handleImage}
										imageUrl={modalValue.image?.url || ''}
									/>
								</Column>
							</ImageInputWrapper>

							<SwitchWrapper>
								<LanguageLabel>IDIOMA</LanguageLabel>
								<SwicthLabelContainer>
									<SwitchLanguage
										setSwitchValue={setSwitchValue}
										switchValue={switchValue}
									/>
								</SwicthLabelContainer>
							</SwitchWrapper>

							<Row>
								<Column sm='12' lg='6'>
									{window.innerWidth > 480 ? (
										<FloatLabelInput
											id='title'
											label='Título'
											value={modalValue.title}
											onChange={(e) => handleTitle(e.target.value)}
											{...primaryInputStyle}
											className='input'
										/>
									) : (
										<ResponsiveInput
											id='title'
											label='Título'
											value={modalValue.title}
											onChange={handleTitle}
											{...primaryInputStyle}
											className='input'
										/>
									)}
									<Select
										id='author'
										label='Autor'
										options={modalOptions.authorsOptions}
										placeholder={'Selecione um autor'}
										value={modalValue.selectedAuthor}
										onChange={(value: any) => handleSelectChange(value)}
										{...selectStyle}
										className='select'
									/>
									<Select
										id='category'
										label='Categoria'
										isDisabled={false}
										options={modalOptions.categoryOptions}
										placeholder={'Selecione um categoria'}
										value={modalValue.category}
										onChange={handleSelectCategoryChange}
										{...selectStyle}
										className='select'
									/>
								</Column>
								<Column sm='12' lg='6'>
									{window.innerWidth > 480 ? (
										<FloatLabelInput
											id='subtitle'
											label='Subtítulo (Opcional)'
											value={modalValue.subtitle}
											onChange={(e) => handleSubtitle(e.target.value)}
											{...primaryInputStyle}
											className='input'
										/>
									) : (
										<ResponsiveInput
											id='subtitle'
											label='Subtítulo (Opcional)'
											value={modalValue.subtitle}
											onChange={handleSubtitle}
											{...primaryInputStyle}
											className='input'
										/>
									)}

									<FloatLabelInput
										id='youtube-link'
										label='Link Vídeo (Youtube)'
										value={modalValue.youtubeLink}
										onChange={handleYoutubeLink}
										{...primaryInputStyle}
										className='input'
									/>

									{modalOptions.subcategoryOptions && (
										<Select
											id='subcategory'
											label='Subcategoria'
											options={modalOptions.subcategoryOptions}
											placeholder={'Selecione uma subcategoria'}
											value={modalValue.subcategory}
											onChange={handleSelectSubcategory}
											{...selectStyle}
											className='select'
										/>
									)}

									<FloatLabelInput
										id='graph-link'
										label='Link Gráfico (Power BI)'
										value={graphLink}
										onChange={handleGraphLink}
										{...primaryInputStyle}
										className='input'
									/>
								</Column>
							</Row>
						</div>

						{!!isBzElectionCategory && (
							<SectionBZElections
								BZElectionAccess={!!BZElectionAccess}
								handleElectionAccess={handleElectionAccess}
								delayTimeInMacroPolitical={delayTimeInMacroPolitical}
								handleDelayMinuteChange={handleDelayMinuteChange}
								isFixed={isFixed}
								handleIsFixed={handleIsFixed}
							/>
						)}

						{isSpeech && (
							<div className='speech-form'>
								<SectionSpeechForm
									selectChange={handleSpeechChange}
									textInputChange={handleSpeechTextInput}
									value={speechValue}
									listData={speechDate}
								/>
							</div>
						)}

						<div className='text-editor-area'>
							<EditorTextBox
								value={modalValue.body}
								returnValue={handleEditor}
								isActive={isActive}
							/>
						</div>

						<div className='list-pdfs-files'>
							<PdfFiles
								returnPdf={handlePdf}
								initialPdfs={currentReport.attachments}
							/>
						</div>

						<ModalConfigurationTitle children='Configurações do Latest' />

						<SwitchesRow className='first-switch-row' switchesQuantity={2}>
							<SwitchesRowLabel>Notificar Clientes:</SwitchesRowLabel>
							<SwitchesWrapper>
								<SwitchContainer>
									<Switch
										label='Push'
										isChecked={modalValue.notificate}
										onChange={setNotificate}
									/>
								</SwitchContainer>
								<SwitchContainer>
									<Switch
										label='E-mail'
										isChecked={modalValue.emailNotificate}
										onChange={setEmailNotificate}
									/>
								</SwitchContainer>
							</SwitchesWrapper>
						</SwitchesRow>

						<Separator />

						<SwitchesRow className='last-switch-row' switchesQuantity={1}>
							<SwitchesRowLabel>Visibilidade:</SwitchesRowLabel>
							<SwitchesWrapper>
								<SwitchContainer>
									<Switch
										label='Público'
										isChecked={modalValue.isPublic}
										onChange={setIsPublic}
									/>
								</SwitchContainer>
							</SwitchesWrapper>
						</SwitchesRow>

						<ViewErrors errors={modalOptions.viewErrors} color='red' />

						{isLoading ? (
							<div className='loading-wrapper'>
								<Loading type='Sentry' primaryColor={colors.secondary} />
							</div>
						) : (
							<Button
								className='modal-button'
								disabled={!modalValue.isFormValid}
								onClick={handleSubmit}
								{...primaryButtonStyle}
							>
								{defineModalButtonName(modalAction)}
							</Button>
						)}
					</ModalReportWrapper>
				) : (
					<ModalDeleteReport>
						<p>Você deseja excluir o Latest</p>
						<p>"{currentReport.title}"?</p>
						{isLoading ? (
							<Loading type='Sentry' primaryColor={colors.secondary} />
						) : (
							<Button onClick={() => handleDelete(currentReport._id)}>
								{'EXCLUIR'}
							</Button>
						)}
					</ModalDeleteReport>
				)}
			</Modal>
		</ModalContainerWrapper>
	)
}

export default ModalReport
